import { Expertises } from '@platform/client';
import { MultiSelectDropdown } from '@platform/components';
import { UseFormRegisterReturn } from 'react-hook-form';

type SkillCategorySelectionDropdownProps = {
  selectedCategories: string[];
  onCategorySelectionChange: (categories: string[]) => void;
  register?: () => UseFormRegisterReturn<string>;
  errors?: Record<string, { message: string } | undefined>;
  label: string;
  placeholder?: string;
  selectionLimit?: number;
};

export const SkillCategorySelectionDropdown = ({
  selectedCategories,
  onCategorySelectionChange,
  register,
  errors,
  placeholder,
  label,
  selectionLimit,
}: SkillCategorySelectionDropdownProps) => {
  const expertisesList = Expertises.useGetExpertises();

  const categoryOptions =
    expertisesList.isSuccess ?
      Array.from(new Set(expertisesList.data.map((expertise) => expertise.classification))).map(
        (classification) => ({ label: classification }),
      )
    : [];

  return (
    <MultiSelectDropdown
      register={register}
      selectedItems={selectedCategories}
      onSelectionChange={onCategorySelectionChange}
      options={categoryOptions}
      selectionLimit={selectionLimit}
      label={label}
      placeholder={placeholder || 'Select skill category'}
      error={errors?.skillCategories?.message}
      filterable={true}
    />
  );
};
